"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeekDaysRowHeader = exports.WeekDaysRow = exports.WeekDaysContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const DayCell_1 = require(".././atoms/DayCell");
const elements_1 = require("../../../elements");
const are_all_selected_1 = require("../utils/are-all-selected");
const constants_1 = require("../utils/constants");
exports.WeekDaysContainer = (0, styled_1.default)(elements_1.Flex)({
    height: '100%',
    boxSizing: 'border-box',
});
const WeekDaysRow = ({ days, toggleDay, viewState, disabled, getDayCellStatus, }) => {
    return ((0, jsx_runtime_1.jsx)(exports.WeekDaysContainer, { children: days.map((day, index) => ((0, jsx_runtime_1.jsx)(DayCell_1.DayCell, { weekDisabled: disabled, viewState: viewState, day: day, onClick: toggleDay ? () => toggleDay(index) : undefined, getDayCellStatus: getDayCellStatus }, day.date.toString()))) }));
};
exports.WeekDaysRow = WeekDaysRow;
const WeekDaysRowHeaderView = () => ((0, jsx_runtime_1.jsx)(exports.WeekDaysContainer, { children: constants_1.WEEK_DAY_INDICES.map((index) => ((0, jsx_runtime_1.jsx)(DayCell_1.DayCellHeader, { index: index }, index))) }));
const WeekDaysRowHeaderEdit = ({ availabilities, toggleDays, }) => {
    const daySelectionStates = (0, are_all_selected_1.areAllDaysSelected)(availabilities);
    const toggleDay = (dayIndex) => {
        toggleDays?.({
            dayIndex,
            newValue: !daySelectionStates[dayIndex].areAllSelected,
        });
    };
    return ((0, jsx_runtime_1.jsx)(exports.WeekDaysContainer, { children: constants_1.WEEK_DAY_INDICES.map((index) => ((0, jsx_runtime_1.jsx)(DayCell_1.DayCellHeader, { index: index, children: (0, jsx_runtime_1.jsx)(elements_1.Checkbox, { size: "sm", indeterminate: !daySelectionStates[index].areAllSelected, checked: daySelectionStates[index].isSomeSelected, onChange: () => toggleDay(index), disabled: daySelectionStates[index].disabled }) }, index))) }));
};
const WeekDaysRowHeader = ({ availabilities, toggleDays, viewState, }) => {
    switch (viewState) {
        case 'edit':
            return ((0, jsx_runtime_1.jsx)(WeekDaysRowHeaderEdit, { availabilities: availabilities, toggleDays: toggleDays }));
        case 'view':
            return (0, jsx_runtime_1.jsx)(WeekDaysRowHeaderView, {});
    }
};
exports.WeekDaysRowHeader = WeekDaysRowHeader;
